import { connect } from 'react-redux'
import {
  selectShouldBootstrap,
  selectOnboardingLayoutVariant,
} from './selectors'
import { doBootstrapOnboarding } from './actions'
import OnboardingSubapp from './view'

const select = state => {
  return {
    shouldBootstrap: selectShouldBootstrap(state),
    layoutVariant: selectOnboardingLayoutVariant(state),
  }
}

const perform = {
  doBootstrapOnboarding,
}

export default connect(select, perform)(OnboardingSubapp)
